import React from "react";
import "./style.scss";

interface OptionScaleButtonProps {
  text: string | number;
  isSelected: boolean;
  index: number;
  handleClick: (index: number) => void;
}

const OptionScaleButton: React.FC<OptionScaleButtonProps> = ({ text, isSelected, index, handleClick }) => {
  return (
    <div
      className={`option-button-container ${isSelected ? "selected" : ""}`}
      onClick={() => handleClick(index)}
    >
      {text}
    </div>
  );
};

export default OptionScaleButton;
